import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from '../../../service/user-management.service';
import { RecipientManagementService } from '../../../service/recipient-management.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'recipient-edit',
  templateUrl: './recipient-edit.component.html',
  styleUrls: ['./recipient-edit.component.css']
})
export class RecipientEditComponent implements OnInit {
  recipientData: any;
  message: string = '';
  msgs: Message[] = [];

  constructor(public route: ActivatedRoute, public dataService: UserManagementService, public recipientService: RecipientManagementService, public router: Router) {
    
  }

  ngOnInit() {

    this.getRecipient();
  }

  getRecipient() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.recipientService.getRecipient(id).subscribe(result => {
        this.recipientData = result;
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה באחזור הודעה');
      });
    } else {
      this.recipientData = {
        FirstName: null,
        LastName: null,
        Name: null,
        Phone1: null,
        Phone2: null,
        Address: null,
        Id: null,
        Active: true,
        EMail: null,
        Notes: null

      };
    }
  }


  onSubmit(f: NgForm) {
    if (f.valid) {
      // this.user.Id = this.route.snapshot.paramMap.get('id');
      this.recipientData.FirstName = f.value.FirstName;
      this.recipientData.LastName = f.value.LastName;
      this.recipientData.Phone1 = f.value.Phone1;
      this.recipientData.Phone2 = f.value.Phone2;
      this.recipientData.Address = f.value.Address;
      this.recipientData.EMail = f.value.EMail;
      this.recipientData.Active = f.value.Active;
      this.recipientData.Notes = f.value.Notes;
      this.recipientService.SaveRecipient(this.recipientData).subscribe(res => {
        this.showMessage('success', '', 'פרטי נמען נשמרו');
            this.router.navigate(['recipients-list']);
         
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בשמירת פרטי נמען');
      });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/recipient-management/recipients/recipient-edit/recipient-edit.component.ts